var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.00784H11.82C11.4 0.848958 10.3 0.00976562 9 0.00976562C7.7 0.00976562 6.6 0.848958 6.18 2.00784H2C0.9 2.00784 0 2.90698 0 4.00592V17.9925C0 19.0914 0.9 19.9905 2 19.9905H16C17.1 19.9905 18 19.0914 18 17.9925V4.00592C18 2.90698 17.1 2.00784 16 2.00784ZM9 2.00784C9.55 2.00784 10 2.45741 10 3.00688C10 3.55635 9.55 4.00592 9 4.00592C8.45 4.00592 8 3.55635 8 3.00688C8 2.45741 8.45 2.00784 9 2.00784ZM11 15.9944H4V13.9963H11V15.9944ZM14 11.9982H4V10.0002H14V11.9982ZM14 8.00208H4V6.004H14V8.00208Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateBook);
export default __webpack_public_path__ + "static/media/template_book.8383c58a65bbf5fb7fe2abaac420817b.svg";
export { ForwardRef as ReactComponent };